import { invoke } from '@vueuse/core'

export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuthStore()

  invoke(async () => {
    await until(() => auth.isAdmin).toMatch((v) => typeof v === 'boolean')

    if (!auth.isAdmin) {
      const toast = useToast()

      toast.add({
        color: 'red',
        title: 'You are not authorized to view this page.',
      })

      if (to.path !== '/') {
        return navigateTo('/')
      }
    }
  })
})
